import React from "react";
import { useIntl } from "react-intl";

import { ReactComponent as SadFaceIcon } from "static/icons/sad-face.svg";
import styles from "./GlobalErrorLayout.module.scss";

const GlobalErrorLayout = () => {
    const intl = useIntl();
    return (
        <div className={styles["error"]}>
            <h1 className={styles["error__title"]}>
                {intl.formatMessage({
                    id: "common_error.title",
                })}
            </h1>
            <SadFaceIcon className={styles["error__icon"]} />
            <p className={styles["error__description"]}>
                {intl.formatMessage({
                    id: "common_error.description",
                })}
            </p>
        </div>
    );
};

export default GlobalErrorLayout;
